import React from 'react';
import Select from 'react-select';
import IndefiniteProgressbar from "../IndefiniteProgressbar.mjs";

class SelectEnti extends React.Component {
	constructor(opts) {
		super(opts);
		this.state = { enti: window.glob.getStatus('listaEntiOptions') };
		this.loadEnti.bind(this);
		this.enti2options.bind(this);
		this.onchange.bind(this);
		this.id = "SelectEnti-"+window.glob.generateUid();
	};
	loadEnti() {
		let el = window.glob.getStatus('listaEnti');
		if ( el ) {
			this.enti2options(el);
			return;
		}
		window.glob.api('lsEnti').then( (e)=>{
			window.glob.setStatus('listaEnti', e);
			this.enti2options(e);
		})
	};
	enti2options(enti) {
		let opts = window.glob.getStatus('listaEntiOptions');
		if ( ! opts ) {
			const groups = {};
			enti.forEach( e =>{
				if ( ! groups[e.ldesc] ) groups[e.ldesc] = { label: e.ldesc, options: [] };
				groups[e.ldesc].options.push({ label: `${e.lnomeof}${e.lclasse && '  '+e.lclasse}`, value: JSON.stringify(e) });
			});
			const gks = Object.keys(groups).sort();
			opts = [];
			gks.forEach( gn => {
				const o = groups[gn].options.sort( (a,b)=>{ return a.label < b.label ? -1 : 1 });
				groups[gn].options = o;
				opts.push( groups[gn] );
			});
			window.glob.setStatus('listaEntiOptions',opts);
		}
		this.setState({ enti: opts });
	}
	onchange(s) {
		if ( this.props.globPrefix && this.props.name ) {
			window.glob.trigger(
				this.props.globPrefix+'changed',
				{ name: this.props.name, value: JSON.parse( s.value) }
			);
		}
	}
	render() {
		if ( ! this.state.enti ) {
			setTimeout( ()=>{ this.loadEnti() }, 1);
			return <p className={"comment"}><IndefiniteProgressbar /></p>;
		}
		return (
			<Select
				id={this.id}
				options={this.state.enti}
				className={"w-100"}
				autoFocus={true}
				onChange={ (s)=> { this.onchange(s) }}
				isDisabled={!this.state.enti}
			/>
		);
	}
}

export default SelectEnti;